'use es6';

import { push } from './update';
var responseHandlersKey = Symbol('responseHandlers');
export var responseHandlers = function responseHandlers(options) {
  return options[responseHandlersKey];
};
export var handleResponse = function handleResponse(handler) {
  return push(responseHandlersKey, handler);
};
export var responseError = function responseError(response, message, code, previousError) {
  return Object.assign(new Error(), response, {
    message: message,
    code: code,
    previousError: previousError
  });
};